/**
 * Action Card component for dashboard quick actions
 */

import { Card, CardContent } from './card';
import { Icon, type IconName } from './icon';
import { cn } from '@/lib/utils';

export interface ActionCardProps {
  title: string;
  description?: string;
  icon?: IconName;
  onClick?: () => void;
  className?: string;
  testId?: string;
}

export function ActionCard({
  title,
  description,
  icon,
  onClick,
  className,
  testId,
}: ActionCardProps) {
  return (
    <Card
      className={cn(
        'cursor-pointer transition-colors hover:bg-accent',
        className
      )}
      onClick={onClick}
      data-testid={testId}
    >
      <CardContent className="flex items-center gap-4 p-4">
        {icon && (
          <div className="rounded-lg bg-primary/10 p-2">
            <Icon name={icon} className="h-5 w-5 text-primary" />
          </div>
        )}
        <div className="flex-1 space-y-1">
          <p className="text-sm font-medium leading-none">{title}</p>
          {description && (
            <p className="text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        <Icon name="chevron-right" className="h-4 w-4 text-muted-foreground" />
      </CardContent>
    </Card>
  );
}
